<dx-popup
  [showTitle]="true"
  title="Rapprocher manuellement l'avoir externe"
  [visible]="displayDialog()"
  (onHidden)="closeDialog()"
  [fullScreen]="true"
  [resizeEnabled]="true"
  [showCloseButton]="true">

  <div class="filters">
    <dx-text-box
      placeholder="Filtrer par numéro d'avoir fournisseur..."
      [value]="numeroAvoirFilter()"
      (onValueChanged)="numeroAvoirFilter.set($event.value)"
      [showClearButton]="true">
    </dx-text-box>
  </div>

  <dx-load-panel
    [visible]="avoirFournisseurListResource.isLoading()"
    [showPane]="true"
    [showIndicator]="true"
    message="Chargement...">
  </dx-load-panel>

  <dx-data-grid
    [dataSource]="avoirFournisseurListResource.value() ?? []"
    keyExpr="id"
    class="datagrid"
    [showBorders]="true"
    [showRowLines]="true"
    [rowAlternationEnabled]="true"
    [hoverStateEnabled]="true"
    [allowColumnResizing]="true"
    columnResizingMode="widget"
    noDataText="Pas de données">

    <dxi-column dataField="id" caption="Actions" [width]="70"
                [allowFiltering]="false" [allowGrouping]="false" [allowSorting]="false"
                cellTemplate="actionsCellTemplate">
    </dxi-column>
    <dxi-column dataField="statut" caption="Statut"></dxi-column>
    <dxi-column dataField="facture.site.libelle" caption="Site"></dxi-column>
    <dxi-column dataField="code" caption="Numéro d'avoir"></dxi-column>
    <dxi-column dataField="facture.fournisseur.libelle" caption="Fournisseur"></dxi-column>
    <dxi-column dataField="facture.numero" caption="Facture"></dxi-column>
    <dxi-column dataField="reference" caption="Référence"></dxi-column>
    <dxi-column dataField="montant.value" caption="Montant" dataType="number"
                cellTemplate="montantTemplate" alignment="right">
    </dxi-column>
    <dxi-column dataField="montantValide.value" caption="Montant validé" dataType="number"
                cellTemplate="montantValideTemplate" alignment="right">
    </dxi-column>
    <dxi-column dataField="bonLivraisonNumeroList" caption="Bon(s) de livraison"
                [allowSorting]="false" [allowFiltering]="false"
                cellTemplate="bonLivraisonCellTemplate">
    </dxi-column>

    <div *dxTemplate="let cell of 'actionsCellTemplate'" class="custom-button-container">
      <yo-button size="small"
                 [theme]="ButtonThemeEnum.VALIDATE_INNER"
                 (onClick)="selectAvoirFournisseur(cell.row.data)"
                 iconClass="fas fa-check"
                 tooltip="Rapprocher cet avoir fournisseur">
      </yo-button>
    </div>

    <div *dxTemplate="let cell of 'montantTemplate'">
      {{ getPrixDisplayValue(cell.row.data.montant) }}
    </div>

    <div *dxTemplate="let cell of 'montantValideTemplate'">
      {{ getPrixDisplayValue(cell.row.data.montantValide) }}
    </div>

    <div *dxTemplate="let cell of 'bonLivraisonCellTemplate'">
      {{ formatBonLivraisonList(cell.row.data.bonLivraisonNumeroList) }}
    </div>

    <dxo-pager
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[20, 50, 100]"
      [visible]="true"
      [showInfo]="true"
      infoText="{2} avoirs fournisseur">
    </dxo-pager>
    <dxo-paging [pageSize]="20"></dxo-paging>
  </dx-data-grid>
</dx-popup>
